<template>
    <div v-html="filters.drawStarsWithText(rating, reviews)"></div>
</template>
<script>
    export default {
        props: ['rating', 'reviews'],
    }
</script>
